import React, { useState, useEffect } from 'react';
import { RootState } from 'src/store/reducers/state';
import { useSelector, useDispatch } from 'react-redux';
import { useChannelActions } from 'src/store/channel/actions';
import { useForm, Controller } from 'react-hook-form';
import { customFilterOption } from 'src/components/utilities/utils';
import { useEventActions } from 'src/store/event/actions';
import { SelectModel } from 'src/models/videosModel';
import Select from 'react-select';
import Loader from 'src/components/loader';
import moment from 'moment';
import Pagination from 'src/components/common/pagination';
import { DebounceInput } from 'react-debounce-input';
import CreateNewContent from './CreateNewContent';
import { getDateAndTime, getDateAndTimes } from 'src/components/utilities/utils';
import { useNavigate, useParams } from 'react-router-dom';
import { getEventType } from 'src/components/utilities/utils'
import { useVideosActions } from 'src/store/videos/actions';
import { getBadge } from 'src/components/utilities/utils';
const SelectOrCreateContent = ({ setCurrentStep, setNewVideoData, eventTitle, newVideoData, selectedContentType, setChannelName, channelName }: any) => {
    const dispatch = useDispatch()
    const { eventId } = useParams<string>();
    const channelAction = useChannelActions(dispatch);
    const eventActions = useEventActions(dispatch)
    const videoAction = useVideosActions(dispatch);
    const navigate = useNavigate()
    const accountInformation = localStorage.getItem('accountInformation');
    const parsedAccount = accountInformation && JSON.parse(accountInformation);
    const [activeTab, setActiveTab] = useState<'existing' | 'new'>('existing');
    const [search, setSearch] = useState('');
    const [selectedRowId, setSelectedRowId] = useState<string | null>(null);
    const [channelId, setChannelId] = useState('');
    const [finalChannels, setFinalChannels] = useState<SelectModel[]>();
    const [selectedContent, setSelectedContent] = useState<any>();
    const [showChangeContent, setShowChangeContent] = useState(false);
    const changeContentRef = React.useRef<HTMLDivElement>(null);
    const [isNewContentCreated, setIsNewContentCreated] = useState(false);
    const handleChangeContentClick = () => {
        setShowChangeContent(true);
        setTimeout(() => {
            changeContentRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 50);
    };
    const {
        watch,
        formState: { errors },
        control,
        setValue
    } = useForm();
    const channelIds = watch('selectedChannel');
    const {
        singleEvent,
        channelList,
        eventVideo,
        isEventVideoLoading,
        paginationMeta,
        isVideoUploaded,
        liveStreamId,
        singleVideo,
        singleChannel,
        isGetSingleEventLoading
    } = useSelector((state: RootState) => {
        return {
            singleEvent: state.event.singleEvent,
            channelList: state.channel.channelList,
            eventVideo: state.event.eventVideo,
            isEventVideoLoading: state.event.isEventVideoLoading,
            paginationMeta: state.event.paginationMeta,
            isVideoUploaded: state.videos.isVideoUploaded,
            liveStreamId: state.videos.liveStreamId,
            singleVideo: state.videos.singleVideo,
            singleChannel: state.channel.singleChannel,
            isGetSingleEventLoading: state.event.isGetSingleEventLoading
        };
    });
    useEffect(() => {
        channelAction.getChannelListRequest();
    }, []);
    useEffect(() => {
        if (channelList && channelList.length) {
            const options = channelList.map((item) => ({
                value: item.id,
                label: item.displayText
            }));
            const finalChannelOptions = [{ value: '', label: 'Select Channel' }, ...options];
            setFinalChannels(finalChannelOptions);
        }
    }, [channelList]);
    useEffect(() => {
        if (isVideoUploaded && liveStreamId) {
            setSelectedRowId(liveStreamId.videoId);
            setIsNewContentCreated(true);
            setActiveTab('existing');
            setShowChangeContent(false);

            videoAction.getSingleVideosRequest(liveStreamId.videoId);

            if (channelId) {
                eventActions.getEventVideoRequest({
                    channelId,
                    pageNumber: 1,
                    pageSize: 50
                });
            }

            setTimeout(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }, 100);
        }
    }, [isVideoUploaded, liveStreamId]);
    useEffect(() => {
        if (channelList && singleEvent) {
            const selectedChannel =
                channelList && channelList.filter((item) => item.id === singleEvent.selectedChannel);
            if (selectedChannel) {
                const defaultChannel = {
                    value: selectedChannel[0] ? selectedChannel[0].id : '',
                    label: selectedChannel[0] ? selectedChannel[0].displayText : 'Select Channel'
                };
                setValue('selectedChannel', defaultChannel);
                setChannelName(selectedChannel[0]?.displayText)
            }
            setSelectedRowId(singleEvent.selectedVideo)
            setChannelId(singleEvent.selectedChannel)
        }
    }, [channelList, singleEvent]);
    useEffect(() => {
        if (isVideoUploaded && liveStreamId) {
            setSelectedRowId(liveStreamId.videoId);
        }
    }, [isVideoUploaded, liveStreamId]);
    useEffect(() => {
        if (channelIds && channelIds?.value !== '' && selectedContentType != '1') {
            eventActions.getEventVideoRequest({
                channelId: channelIds && channelIds.value
            });
        }
    }, [channelIds]);
    useEffect(() => {
        if (eventId) {
            eventActions.getSingleEventRequest(eventId);
        }
    }, [eventId]);
    useEffect(() => {
        if (
            singleVideo &&
            Object.keys(singleVideo).length &&
            singleVideo.id === (selectedRowId || singleEvent?.selectedVideo)
        ) {
            setSelectedContent(singleVideo);
        } else if (!selectedRowId && !singleEvent?.selectedVideo) {
            setSelectedContent(undefined);
        }
    }, [singleVideo, selectedRowId, singleEvent?.selectedVideo]);

    useEffect(() => {
        if (channelId) {
            channelAction.getSingleChannelRequest(channelId)
        }
    }, [channelId])
    const handleChannelChange = (channelId: any) => {
        setChannelName(channelId.label)
        setChannelId(channelId.value)
        eventActions.getEventVideoRequest({
            channelId: channelId.value,
            pageNumber: 1,
            pageSize: 50
        });
    };
    const handleVideoSelect = (data: any) => {
        if (selectedRowId === data.id) {
            setSelectedRowId(null);
            setNewVideoData({
                date: '',
                time: '',
                duration: '',
                videoId: '',
                videoTitle: ''
            });

            return;
        }
        setIsNewContentCreated(true);
        setSelectedRowId(data.id);
        setChannelName(data.channelName)
        setSelectedContent(data)
        const dateAndTime: any = getDateAndTime(data.recordDate);
        setNewVideoData({
            date: new Date(dateAndTime.formattedDate),
            time: dateAndTime.formattedTime,
            duration: moment(data.duration, 'hh:mm:ss').format('HH:mm'),
            videoId: data.id,
            videoTitle: data.title
        });
    };
    const SelectVideoType = (value: number) => {
        if (value === 0) {
            return 'Paid';
        } else if (value === 1) {
            return 'Free';
        } else if (value === 2) {
            return 'Locked';
        }
    };
    console.log(selectedContent)
    const handlePageChange = (pageNumber: number) => {
        eventActions.getEventVideoRequest({
            channelId,
            pageNumber,
            pageSize: 50,
            criteria: search
        })
    };
    const handleSearchVideo = (searchText: string) => {
        setSearch(searchText)
        eventActions.getEventVideoRequest({
            channelId,
            criteria: searchText,
            pageNumber: 1,
            pageSize: 50,
        })
    }
    const submitData = () => {
        if (!singleEvent?.id) {
            return;
        }
        const patchJsonModel = {
            id: singleEvent.id,
            patchJsonData: [{ op: 'replace', path: 'selectedChannel', value: channelId },
            { op: 'replace', path: 'selectedVideo', value: selectedRowId },
            ]
        };
        eventActions.updateEventRequest(patchJsonModel)
        setCurrentStep(3)
    }
    const dateAndTime = getDateAndTimes(
        selectedContent?.recordDate,
        parsedAccount?.dateFormat
    );

    return (

        <>
            <main className="flex-1 flex flex-col min-w-0">
                <div className="bg-white rounded-xl border border-gray-200 flex-1 flex flex-col">
                    <div className="flex items-start justify-between gap-3 px-4 sm:px-8 pt-5 sm:pt-6">
                        <div className="min-w-0">
                            <h2 className="text-lg font-semibold text-gray-900 m-0">Select or Create Content</h2>
                            <p className="text-sm text-gray-400 mt-1">Choose the live stream, channel or play page that this registration will link to.</p>
                        </div>
                        <button type="button" onClick={() => { navigate('/events/event') }} className="flex items-center gap-1.5 text-sm font-semibold text-gray-500 border border-gray-200 rounded-lg px-3 py-1.5 hover:bg-gray-50">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                <line x1="18" y1="6" x2="6" y2="18" />
                                <line x1="6" y1="6" x2="18" y2="18" />
                            </svg>
                            Exit
                        </button>
                    </div>

                    {/* Selected Content Card */}
                    {(selectedContent || singleEvent?.selectedVideo || selectedContentType == 1) && (
                        <div className="mx-4 sm:mx-8 mt-5 sm:mt-6 border-2 border-indigo-200 rounded-xl p-4 sm:p-5 bg-indigo-50">
                            <h3 className="text-sm font-semibold text-gray-900 m-0">Selected Content</h3>
                            <p className="text-xs text-gray-400 mt-1 mb-4">
                                This registration page is currently linked to the following content.
                            </p>

                            <div className="flex flex-col md:flex-row md:items-center gap-4">

                                <div
                                    className="w-full md:w-40 rounded-lg flex-shrink-0 overflow-hidden bg-gradient-to-br from-indigo-900 to-slate-900 flex items-center justify-center"
                                    style={{ height: '90px' }}
                                >
                                    {
                                        selectedContentType == 1 ? (<>{singleChannel?.channelImageUrl &&
                                            <img
                                                src={singleChannel.channelImageUrl}
                                                alt={singleChannel?.title || 'Content thumbnail'}
                                                className="w-full h-full object-cover"
                                                onError={(e) => {
                                                    (e.target as HTMLImageElement).style.display = 'none';
                                                }}
                                            />
                                        }</>
                                        ) : (<> {selectedContent?.thumbnailUrl ? (
                                            <img
                                                src={selectedContent.thumbnailUrl}
                                                alt={selectedContent?.title || 'Content thumbnail'}
                                                className="w-full h-full object-cover"
                                                onError={(e) => {
                                                    (e.target as HTMLImageElement).style.display = 'none';
                                                }}
                                            />
                                        ) : (
                                            <span className="text-white text-xs font-bold tracking-wide">
                                                {selectedContent?.title?.charAt(0)?.toUpperCase() || 'V'}
                                            </span>
                                        )}</>)
                                    }

                                </div>


                                <div className="flex-1 min-w-0">
                                    <p className="text-sm font-semibold text-gray-900 m-0 mb-2 break-words ">
                                        {selectedContentType == 1 ? (channelName ? channelName : selectedContent?.channelName) : selectedContent?.title}
                                    </p>

                                    <table className="text-sm w-full">
                                        <tbody>
                                            <tr>
                                                <td className="text-gray-400 pr-3 sm:pr-6 py-0.5 align-top whitespace-nowrap w-20 sm:w-24">Type</td>
                                                <td className="text-gray-700 py-0.5 break-words">{getEventType(selectedContentType)}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-gray-400 pr-3 sm:pr-6 py-0.5 align-top whitespace-nowrap w-20 sm:w-24">Channel</td>
                                                <td className="text-gray-700 py-0.5 break-words">{channelName ? channelName : selectedContent?.channelName}</td>
                                            </tr>
                                            {
                                                selectedContentType != 1 && (
                                                    <>
                                                        <tr>
                                                            <td className="text-gray-400 pr-3 sm:pr-6 py-0.5 align-top whitespace-nowrap w-20 sm:w-24">Date &amp; Time</td>
                                                            <td className="text-gray-700 py-0.5 break-words">
                                                                {dateAndTime?.formattedDate}, {dateAndTime?.formattedTime} {parsedAccount?.timeZone}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="text-gray-400 pr-3 sm:pr-6 py-0.5 align-top whitespace-nowrap w-20 sm:w-24">Status</td>
                                                            <td className="py-0.5">
                                                                {getBadge(selectedContent?.videoStatus)}
                                                            </td>
                                                        </tr>
                                                    </>
                                                )
                                            }

                                        </tbody>
                                    </table>
                                </div>


                                <div className="grid grid-cols-2 sm:grid-cols-3 md:flex md:flex-col gap-2 flex-shrink-0 w-full md:w-auto">
                                    {/* Preview */}
                                    <button
                                        type="button"
                                        onClick={() => window.open(selectedContentType == 1 ? singleChannel?.channelUrl : singleVideo?.playUrl, '_blank')}
                                        className="flex-1 md:flex-none flex items-center justify-center gap-1.5 text-sm font-semibold text-indigo-600 border border-indigo-200 rounded-lg px-4 py-2 hover:bg-indigo-50"
                                    >
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                            <polyline points="15 3 21 3 21 9" />
                                            <line x1="10" y1="14" x2="21" y2="3" />
                                        </svg>
                                        Preview
                                    </button>

                                    {/* Edit Content */}
                                    <button
                                        type="button"
                                        onClick={() => window.open(selectedContentType == 1 ? `/channels/edit/${channelId}` : `/videos/${selectedContent?.id}`, '_blank')}
                                        className="flex-1 md:flex-none flex items-center justify-center gap-1.5 text-sm font-semibold text-indigo-600 border border-indigo-200 rounded-lg px-4 py-2 hover:bg-indigo-50"
                                    >
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M12 20h9" />
                                            <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
                                        </svg>
                                        Edit Content
                                    </button>

                                    <button
                                        type="button"
                                        onClick={handleChangeContentClick}
                                        className="col-span-2 sm:col-span-1 flex-1 md:flex-none flex items-center justify-center gap-1.5 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg px-4 py-2 whitespace-nowrap"
                                    >
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <polyline points="16 3 21 3 21 8" />
                                            <line x1="4" y1="20" x2="21" y2="3" />
                                            <polyline points="21 16 21 21 16 21" />
                                            <line x1="15" y1="15" x2="21" y2="21" />
                                            <line x1="4" y1="4" x2="9" y2="9" />
                                        </svg>
                                        Change Content
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {(selectedContent || singleEvent?.selectedVideo) && (
                        <div
                            ref={changeContentRef}
                            className="flex items-center justify-between gap-3 px-4 sm:px-8 mt-5 sm:mt-6 cursor-pointer select-none"
                            onClick={() => setShowChangeContent((prev) => !prev)}
                        >
                            <div className="flex items-center gap-2 min-w-0">
                                <svg
                                    width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
                                    className={`flex-shrink-0 text-indigo-600 transition-transform ${showChangeContent ? 'rotate-90' : ''}`}
                                >
                                    <polyline points="9 18 15 12 9 6" />
                                </svg>
                                <div>
                                    <p className="text-sm font-semibold text-gray-900 m-0">Choose Different Content</p>
                                    <p className="text-xs text-gray-400 m-0">Search or select another live stream, channel or video to link to this registration page.</p>
                                </div>
                            </div>
                            <svg
                                width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
                                className={`flex-shrink-0 text-gray-400 transition-transform ${showChangeContent ? 'rotate-180' : ''}`}
                            >
                                <polyline points="6 9 12 15 18 9" />
                            </svg>
                        </div>
                    )}

                    {(showChangeContent || !(selectedContent || singleEvent?.selectedVideo)) && (
                        <>
                            {/* Tabs */}
                            <div className="flex items-center gap-6 px-4 sm:px-8 mt-5 sm:mt-6 border-b border-gray-100">
                                <button
                                    type="button"
                                    onClick={() => setActiveTab('existing')}
                                    className={`text-sm font-semibold pb-3 border-b-2 -mb-px ${activeTab === 'existing' ? 'text-indigo-600 border-indigo-600' : 'text-gray-400 border-transparent'
                                        }`}>
                                    Use Existing
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setActiveTab('new')}
                                    className={`text-sm font-semibold pb-3 border-b-2 -mb-px ${activeTab === 'new' ? 'text-indigo-600 border-indigo-600' : 'text-gray-400 border-transparent'
                                        }`}>
                                    Create New
                                </button>
                            </div>

                            {activeTab === 'existing' ? (
                                <>
                                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-end gap-3 px-4 sm:px-8 mt-5">
                                        {
                                            selectedContentType != '1' && (<div className="form-group flex items-center text-center mb-0 relative w-full sm:w-auto">
                                                <DebounceInput
                                                    minLength={2}
                                                    className="input-style w-full sm:w-52"
                                                    placeholder="Search events..."
                                                    debounceTimeout={500}
                                                    value={search}
                                                    onChange={(event) => handleSearchVideo(event.target.value)}
                                                />
                                                <i className="fa fa-search absolute right-3 text-gray-400 text-xs"></i>
                                            </div>)
                                        }


                                        {channelList && (
                                            <Controller
                                                render={({
                                                    field: { onChange, onBlur, value, ref },
                                                    fieldState: { error }
                                                }) => (
                                                    <Select
                                                        options={finalChannels}
                                                        className='w-full sm:w-64'
                                                        filterOption={customFilterOption}
                                                        value={value}
                                                        id="selectedChannel"
                                                        onChange={(val) => {
                                                            onChange(val), handleChannelChange(val);
                                                        }}
                                                        isLoading={channelList.length ? false : true}
                                                    />
                                                )}
                                                name="selectedChannel"
                                                control={control}
                                                rules={{ required: true }}
                                            />
                                        )}
                                    </div>
                                    {selectedContentType != '1' && (<>
                                        <div className="px-4 sm:px-8 mt-4 overflow-x-auto">
                                            <table className="w-full table-auto min-w-[720px]">
                                                <thead>
                                                    <tr className="text-xs font-semibold text-gray-400 uppercase bg-gray-50">
                                                        <th className="p-3 text-left w-10"></th>
                                                        <th className="p-3 text-left">Title</th>
                                                        <th className="p-3 text-left">Channel</th>
                                                        <th className="p-3 text-left">Date</th>
                                                        <th className="p-3 text-left">Time</th>
                                                        <th className="p-3 text-left">Type</th>
                                                        <th className="p-3 text-left"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {isEventVideoLoading ? (
                                                        <tr>
                                                            <td colSpan={7} className="p-3 text-center">
                                                                <Loader />
                                                            </td>
                                                        </tr>
                                                    ) : eventVideo && eventVideo.length > 0 ? (
                                                        eventVideo.map((item: any) => {
                                                            const isSelected = selectedRowId === item.id;
                                                            return (
                                                                <tr
                                                                    key={item.id}
                                                                    className="border-b border-gray-100 last:border-b-0"
                                                                >
                                                                    <td className="p-3">
                                                                        <button
                                                                            type="button"
                                                                            onClick={() => handleVideoSelect(item)}
                                                                            className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${isSelected
                                                                                ? 'border-indigo-600'
                                                                                : 'border-gray-300'
                                                                                }`}
                                                                        >
                                                                            {isSelected && (
                                                                                <span className="w-2 h-2 rounded-full bg-indigo-600" />
                                                                            )}
                                                                        </button>
                                                                    </td>

                                                                    <td className="p-3 text-sm text-gray-800">
                                                                        {item.title}
                                                                    </td>

                                                                    <td className="p-3 text-sm text-gray-500">
                                                                        {item.channelName}
                                                                    </td>

                                                                    <td className="p-3 text-sm text-gray-500">
                                                                        {moment(item.recordDate).format('DD/MM/YYYY')}
                                                                    </td>

                                                                    <td className="p-3 text-sm text-gray-500">
                                                                        {moment(item.recordDate).format('hh:mm A')}
                                                                    </td>

                                                                    <td className="p-3">
                                                                        <span className="text-xs font-semibold text-green-600 bg-green-50 rounded-full px-2.5 py-1">
                                                                            {SelectVideoType(item.type)}
                                                                        </span>
                                                                    </td>

                                                                    <td className="p-3 text-right">
                                                                        <button
                                                                            type="button"
                                                                            onClick={() =>
                                                                                window.open(`/videos/${item.id}`, '_blank')
                                                                            }
                                                                            className="text-xs font-semibold text-indigo-600 border border-indigo-200 rounded-md px-3 py-1.5 hover:bg-indigo-50"
                                                                        >
                                                                            Preview
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={7} className="p-3">
                                                                <div className="text-center">No data Found</div>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>


                                        {!!paginationMeta && !!Object.keys(paginationMeta).length && (
                                            <Pagination
                                                currentPage={paginationMeta.pageNumber}
                                                totalCount={paginationMeta.totalCount}
                                                pageSize={paginationMeta.pageSize}
                                                onPageChange={(page: any) => handlePageChange(page)}
                                            />
                                        )}
                                    </>)}

                                </>
                            ) : (
                                <CreateNewContent channelName={channelName} eventTitle={eventTitle} setNewVideoData={setNewVideoData} setChannelId={setChannelId} setSelectedRowId={setSelectedRowId} />
                            )}
                        </>
                    )}

                    {/* <div className="flex-1" /> */}


                    <div className="flex justify-between gap-3 px-4 sm:px-8 py-4 sm:py-5 border-t border-gray-100">
                        <button
                            onClick={() => setCurrentStep(1)}
                            type="button"
                            className="flex-shrink-0 flex items-center gap-2 text-sm font-semibold text-gray-600 border border-gray-200 rounded-lg px-4 sm:px-5 py-2.5 hover:bg-gray-50">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                <line x1="19" y1="12" x2="5" y2="12" />
                                <polyline points="12 19 5 12 12 5" />
                            </svg>
                            Back
                        </button>
                        <button
                            onClick={() => submitData()}
                            disabled={isGetSingleEventLoading}
                            type="button"
                            className="flex-1 sm:flex-none justify-center flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg px-4 sm:px-5 py-2.5">

                            {
                                isGetSingleEventLoading ? <>
                                    <svg
                                        className="animate-spin h-4 w-4"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        />
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                        />
                                    </svg>
                                    Loading...
                                </> : (<> {isNewContentCreated ? 'Save and Continue' : 'Next: Event Details'}
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                        <line x1="5" y1="12" x2="19" y2="12" />
                                        <polyline points="12 5 19 12 12 19" />
                                    </svg></>)
                            }
                        </button>
                    </div>
                </div>
            </main >
        </>

    );
};

export default SelectOrCreateContent;